export default __webpack_public_path__ + "static/media/anthony_foster.bb8287e4.jpg";